// extracted by mini-css-extract-plugin
module.exports = {"purpleLink":"styles__purpleLink___2DlQ9","cyanLink":"styles__cyanLink___2mxm1","cyanButton":"styles__cyanButton___8lyGT","ampPage":"styles__ampPage___2vnKE"};